/* eslint-disable react/jsx-max-props-per-line */
import styled from 'styled-components'
import Link from 'next/link'
import Wrapper from 'common/wrapper'
import { usePortfolio } from 'querys/portfolio'
import { SecondaryButton } from 'common/button'
import { MdClose, MdMenu } from 'react-icons/md'
import { AiOutlineDownload } from 'react-icons/ai'

const menu = [
  {
    id: 'hola',
    title: 'Hola',
  },
  {
    id: 'proyectos',
    title: 'Proyectos',
  },
  {
    id: 'testimonios',
    title: 'Testimonios',
  },
  {
    id: 'contacto',
    title: 'Hablemos',
  },
]

const PortfolioNavigationStyled = styled.header`
  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;
  color: white;
  transition: 0.3s ease-out background;
  &.dark {
    background: var(--neutral110);
  }
  .checkbox {
    display: none;
  }
  .close {
    display: none;
  }
  .checkbox:checked {
    ~ .toogle-button  {
      .close {
        display: inline;
      }
      .open {
        display: none;
      }
    }
    ~ .menu-container {
      transform: translateX(0);
    }
  }
  .toogle-button, .logo {
    position: relative;
    z-index: 4;
  }
  .curriculum-btn {
    font: var(--secondaryFont);
    height: 40px;
    font-weight: 600;
  }
  .logo {
    display: block;
  }
  .navigation-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    gap: 24px;
  }
  .menu-container {
    padding: 0;
    padding-block-start: var(--headerBlockSize);
    position: fixed;
    transform: translateX(100%);
    inset: 0;
    background: var(--neutral110);
  }
  .menu {
    &-item {
      display: block;
      padding: 16px 24px;
      font: var(--secondaryFont);
      font-weight: 600;
      &:hover {
        background: #ffffff33;
      }
      &:active {
        background: #ffffff55;
      }
    }
  }
  .curriculum-btn-container {
    position: absolute;
    bottom: 36px;
    right: 16px;
    left: 16px;
  }
  @media (min-width: 768px) {
    .curriculum-btn-container {
      position: static;
      bottom: initial;
      right: initial;
      left: initial;
    }
    .menu {
      display: flex;
      &-item {
        padding: 10px 24px;
      }
    }
    .menu-container {
      flex: 1;
      display: flex;
      position: static;
      align-items: center;
      justify-content: space-between;
      transform: none;
      background: 0;
      padding-block-start: 0;
    }
    .toogle-button {
      display: none;
    }
  }
`

function PortfolioNavigation() {
  const { data } = usePortfolio()
  const { curriculum, testimonies } = data || {}

  return (
    <PortfolioNavigationStyled id="navigation">
      <Wrapper maxWidth={1200}>
        <div className="navigation-container">
          <Link href="/" id="h-home" className="logo">
            <img
              width="53.84"
              height="40"
              src="/icons/icon-105x78.png"
              className="logo"
              alt="El logotipo de la plataforma, un cohete formado por dos triangulos de materiales coloridos y brillantes"
            />
          </Link>
          <input className="checkbox" type="checkbox" id="toogle-button" name="active" />
          <label htmlFor="toogle-button" className="toogle-button">
            <MdMenu className="open" size={30} color="var(--secondary)" />
            <MdClose className="close" size={30} color="var(--secondary)" />
          </label>
          <menu className="menu-container">
            <nav>
              <ul className="menu">
                {menu.map(({ title, id }) => {
                  if (id === 'testimonios' && !testimonies?.length) return null
                  return (
                    <li key={id}>
                      <a className="menu-item" href={`#${id}`}>{title}</a>
                    </li>
                  )
                })}
              </ul>
            </nav>
            {curriculum ? (
              <div className="curriculum-btn-container">
                <SecondaryButton
                  className="curriculum-btn"
                  as="a" href={curriculum} target="_blank" rel="noopener noreferrer"
                  fullWidth fitContent responsive
                >
                  <AiOutlineDownload size={24} color="white" />
                  Descargar Curriculum
                </SecondaryButton>
              </div>
            ) : null}
          </menu>
        </div>
      </Wrapper>
    </PortfolioNavigationStyled>
  )
}

export default PortfolioNavigation
